export class RestoreMicrosoft365SharePointSiteRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreScope",
            "baseName": "restoreScope",
            "type": "Microsoft365SharePointSiteRestoreScope",
            "format": ""
        },
        {
            "name": "selectedItems",
            "baseName": "selectedItems",
            "type": "Microsoft365SharePointSiteSelectedItemsOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365SharePointSiteRequest.attributeTypeMap;
    }
    constructor() {
    }
}
